// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3aCdS","footer":"ModalInfo_footer__3TlnE"};